import EFOcats_branch_core from './efocats_branch_core.js';

/**
 * 分岐判定（等しい）
 */
export default class EFOcats_branch_equal extends EFOcats_branch_core {
  /**
   * 条件判定
   */
  checkCondition(condition) {
    const target = this.$(condition.query);
    if (target.length === 0) {
      return false;
    }
    return target.val() === condition.parameter;
  }
}